import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Master from '../../Store/Master';
import * as PublicDocument from './Saga/PublicDocument';
import Layout from '../Layout/LayoutComponent';
// import './Css/Card.css';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import RentHeaderComponent from '../Layout/RentHeaderComponent';

class LoginComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // comp: false
        };
        this.onChange = this.onChange.bind(this);
        // this.props.change_line_comp(false)
        // this.props.change_cd({ cd: this.props.match.params.cd, no: this.props.match.params.no })
        // this.props.get_line_code(this.props.match.params.cd)
        // // this.handlesubmit = this.handlesubmit.bind(this)
        // this.loginClick = this.loginClick.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }


    onChange(e) {
        this.props.change_rent_limited_public_pages_pass(e.target.value)
    }
    // handlesubmit(state) {
    //     // console.log(state)
    //     // alert()
    //     this.setState({ comp: true })
    // }

    render() {

        return (
            <div className="app" style={{ height: "100%" }}>
                <RentHeaderComponent />
                <div style={{ minHeight: "100%", backgroundColor: "whitesmoke" }}>
                    <div style={{ backgroundColor: "#f5f5f5" }}>
                        <div className="display_style">
                            <div className="container">
                                <div className="frame">
                                    <div className="confirm_h1" style={{textAlign:"center"}}><div>株式会社グローバルセンター</div><div>ログイン</div></div>
                                    <div style={{ textAlign: "center" }}>株式会社グローバルセンターより発行されたパスワードを入力してください。</div>
                                    <div className="container" style={{ marginTop: 80, marginBottom: 50, textAlign: "center" }}>
                                        <TextField
                                            id="filled-password-input"
                                            label="パスワード"
                                            type="password"
                                            name={"cre"}
                                            autoComplete="current-password"
                                            variant="filled"
                                            defaultValue=""
                                            onChange={this.onChange}
                                            onKeyDown={e => {if (e.key === 'Enter') this.props.get_rent_contracts()}}
                                        />
                                    </div>
                                    {this.props.rent_limited_public_pages_err ? <div className="container" style={{marginBottom: 20, textAlign: "center"}}>パスワードが正しくありません。</div>:""}
                                    <div className="container" style={{ marginBottom: 50, textAlign: "center" }}>
                                        <Button variant="contained" color="primary" className="login_btn" onClick={this.props.get_rent_contracts}>ログイン</Button>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



//containers
const mapStateToProps = (state, ownProps) => {
    return {

        rent_limited_public_pages_err: state.PublicDocument.rent_limited_public_pages_err,
    }
}
function mapDispatchToProps(dispatch) {
    return {
        get_rent_contracts(state) {
            dispatch(PublicDocument.get_rent_contracts(state))
        },
        change_rent_limited_public_pages_pass(state) {
            dispatch(PublicDocument.change_rent_limited_public_pages_pass(state))
        },

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginComponent);
